import type { ProgramScopedContentRow } from '../types/domain';

/**
 * 훅 state와 LS 캐시 중 표시용 스코프 행을 고른다.
 * 훅에 행이 있으면 훅이 권위(삭제·빈칸 저장 반영). 훅이 비었을 때만 LS(가져오기·저장 직후 레이스)를 쓴다.
 */
export function pickProgramScopedRowsForDisplay(
  hookRows: ProgramScopedContentRow[],
  cacheRows: ProgramScopedContentRow[]
): ProgramScopedContentRow[] {
  if (!hookRows.length) return cacheRows;
  return hookRows;
}
